import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeActionModal } from '../../../redux/slices/confirmationModalSlice';
import Modal from './Modal';

const ConfirmationModal = () => {
  const dispatch = useDispatch();
  const [isProcessing, setIsProcessing] = useState(false);

  const { heading, description, action, cancelAction, closeAction, closeButtonText, actionButtonText } = useSelector((state) => state.actionModal);

  const handleOnSubmit = async () => {
    try {
      setIsProcessing(true);
      await action();
    } finally {
      setIsProcessing(false);
      dispatch(closeActionModal());
    }
  };

  const handleClose = () => {
    if (closeAction) {
      closeAction();
    }
    dispatch(closeActionModal());
  };

  const handleCancel = () => {
    if (cancelAction) {
      cancelAction();
    }
    dispatch(closeActionModal());
  };

  return (
    <Modal
      id='deleteModal'
      cancelButtonTitle={closeButtonText}
      submitButtonTitle={actionButtonText}
      onSubmit={handleOnSubmit}
      onClose={handleClose}
      onCancel={handleCancel}
      submitButtonDisabled={isProcessing}
      isLoading={isProcessing}
      className='!max-w-[500px]'>
      <h2 className='mb-4 text-xl font-bold text-text'>{heading}</h2>
      <p className='text-base text-text'>{description ?? 'Only an admin will be able to restore.'}</p>
    </Modal>
  );
};

export default ConfirmationModal;
